<template>
<div class="row justify-content-center">
    <div class="col-md-12  bg-white">
        <form @submit.prevent="setFirstPassword()">
            <h5 class="text-center mb-4"><b>Set your first password</b></h5>
            <p class="text-center p-auth">Your new password must pass the following validations</p>
            <ul class="list-group mb-4">
                <li class="p-auth">
                    <div class="text-left mb-2"> 
                        <button class="btn-sm btn-primary icon-pass-neutro" v-if="!password.length" disabled>
                            <i class="icon-info"/>
                        </button>
                        <button class="btn-sm btn-primary" :class="validateLength() ? 'icon-pass-success' : 'icon-pass-warning'" v-else>
                            <i :class="validateLength() ? 'icon-check' : 'icon-close'" />
                        </button>
                        At least 8 characters long
                    </div>
                </li>
                <li class="text-left mb-2 p-auth">
                    <button class="btn-sm btn-primary icon-pass-neutro" v-if="!password.length" disabled>
                            <i class="icon-info"/>
                    </button>
                     <button  class="btn-sm btn-primary" :class="validateUpperCaseLetter() ? 'icon-pass-success' : 'icon-pass-warning'" v-else>
                        <i :class="validateUpperCaseLetter() ? 'icon-check' : 'icon-close'"></i>
                    </button>
                        At least one upper-case letter
                </li>
                <li class="text-left mb-2  p-auth">
                    <div class="mr-0">
                    <button class="btn-sm btn-primary icon-pass-neutro" v-if="!password.length" disabled>
                            <i class="icon-info"/>
                    </button>
                    <button  class="btn-sm btn-primary" :class="validateSpecialCharacters() ? 'icon-pass-success' : 'icon-pass-warning'" v-else>
                            <i :class="validateSpecialCharacters() ? 'icon-check' : 'icon-close'" />
                        </button>
                        At least one special character
                        
                    </div>
                </li>

            </ul>
            <div class="text-left login__input">
                <img src="/assets/img/pass.png" alt="Icon password" class="login__input__icon"/>
                <label for="password">Password</label>
                <input type="password" class="login__input__field" id="password"  placeholder="Enter password" v-model="password" autocomplete="off">
            </div>
            <div class="text-left login__input mt-4" >
               <img src="/assets/img/pass.png" alt="Icon password" class="login__input__icon"/>
                <label for="confirm_password">Confirm password</label>
                <input type="password" class="login__input__field" id="confirm_password" placeholder="Confirm password" v-model="confirm_password">
                <span  class="red-text mt-3" data-error="wrong" data-success="right" v-html="'Confirm password does not match password'" v-if="confirm_password.length && validateConfirmPassword()"/>
            </div>
                <button v-if="!is_loading" type="submit" style="color: white;" class="btn btn-primary mt-4 btn-first-password float-right" :disabled="validateLength() && validateUpperCaseLetter() && validateSpecialCharacters() && !validateConfirmPassword() ? false:true">Submit</button>
                <button v-else type="button" style="color: white;" class="btn btn-primary mt-4 btn-first-password float-right p-2" :disabled="validateLength() && validateUpperCaseLetter() && validateSpecialCharacters() && !validateConfirmPassword() ? false:true">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </button>
            </form>
    </div>
</div>
</template>

<script>

import { Notyf }            from    'notyf'
import 'notyf/notyf.min.css'; 

const notyf = new Notyf({
    duration: 8000,
});
export default {
    data()
    {
        return{
            notyf,
            rest_api: 'auth/first_password',
            password: '',
            confirm_password: '',
            token: '',
            is_loading: false,
        }
    },
    methods:
    {
        async setFirstPassword()
        {
            this.is_loading = true
            const form_data = {
                password: this.password,
                token: this.token
            }

            const response = await this.post(`${this.rest_api}/set_password`, form_data, {}, false)
            this.is_loading = false
            if(response.status)
            {
                if(response.data.token_valid)
                {
                    notyf.success('Password saved')
                    window.location = '/login'
                }
                else
                {
                    notyf.error(response.data.message)
                }
            }
            else
            {
                this.error_handling(response)
            }
        },
        validateLength()
        {
            if(this.password.length >= 8)
            {
                return true
            }
            else
            {
                return false
            }

        },
        validateUpperCaseLetter()
        {
            let password = this.password.split('')
            for (var i = 0; i < password.length; i++) 
            {
                let letter = password[i]
                
                //eslint-disable-next-line
                const format = /[A-Za-z]/;
                if((format).test(letter))
                {
                    if (letter.toUpperCase() === letter) 
                    {
                        return true;
                    } 
                }
            }
           
        },
        validateSpecialCharacters()
        {
            //eslint-disable-next-line
            const format = /[ `!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?¿~¨´°¬]/;
            if((format).test(this.password))
            {
                return true
            }
            else
            {
                return false
            }

        },
        validateConfirmPassword()
        {
            if(this.password === this.confirm_password)
            {
                return false
            }
            else
            {
                return true
            }
        },
        async validRealToken()
        {
            this.token = this.$route.params.token;
            if(this.token)
            {
                const response = await this.get(`${this.rest_api}/check_token/${this.token}`)

                if(response.status)
                {
                    if(response.data.token_valid)
                    {
                        notyf.success('Valid token')
                    }
                    else
                    {
                        notyf.error('Invalid token')
                        window.location = '/'
                    }

                }
                else
                {
                    this.error_handling(response)
                }
            }
            else
            {
                window.location = '/'
            }

        }
    },
    mounted()
    {
        this.validRealToken()
    }

    

}
</script>
